import type { FaireProductEntity } from "../../entity_types/product";

export const p_3yqsapfq82: FaireProductEntity = {
  token: "p_3yqsapfq82",
  type: "product",
  name: "Women's Soft Raglan Crew & Wide Leg Pant Lounge Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/ca385a1f5c5570843bb255ddf539760a29c516aa30d94285e91a2b4a0992f9b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/588faf8a6e31dd061204c4383226614e3f43e54afacf085c4bf2f4d4c43735c7.jpeg",
    "https://cdn.faire.com/fastly/6a6733f2744c2aeab4eeec59f5c1064f2e92dc0b5d6c0839cb7759bb094062b9.jpeg",
    "https://cdn.faire.com/fastly/d31a329b1853a7073f9185b8609525b83fb2323d992fd1478e936325a5e92e6f.png",
    "https://cdn.faire.com/fastly/78a0e1959a12027f833a81eb1e9fdfbe70819d4ff2c1091e478e2c3767e43b15.jpeg",
    "https://cdn.faire.com/fastly/2a4dbd86dc1622fe8e0874e20670f83a7ba5134a676b21bf64c73abde558ff35.jpeg",
    "https://cdn.faire.com/fastly/f190efbd52c1cc631286598d12df39a71e6fc12f442d7e91c119c4a13818e3bf.jpeg",
    "https://cdn.faire.com/fastly/622f4a3ca2b3c475e36e4cc166cdb57d1ee35a74100c1743b73d999e5143a787.png",
    "https://cdn.faire.com/fastly/66bf44c99af8c4b1ab87f3b8c33b56d9e7ab0e51046cfa605dc53f1b05fe5078.jpeg",
    "https://cdn.faire.com/fastly/0494202640a6543374f9efecaffe1a4307cdc9240e70b9d3822dd33ce60f1cc1.jpeg",
    "https://cdn.faire.com/fastly/493e9e7eb04df822d9bc6a860a2996d891f92b050a58c9643a3a126b98b9671d.jpeg",
    "https://cdn.faire.com/fastly/d8159bd9556f958353965e5619f26e210a509c6545cc7bd8cd7f867fffae09ad.jpeg",
    "https://cdn.faire.com/fastly/aabb8cdddf81eb37919d51204d112a58a0f71f59d6136f82d99f09db2ca5fc98.jpeg",
    "https://cdn.faire.com/fastly/923ddf135890ef77e8532830dbd11318aa7aedf47320aebad830da0de457d050.jpeg",
    "https://cdn.faire.com/fastly/8998fa591a2790fa193fbb07f26925fc095c57d06624dc9938d9c15b10790ef9.png"
  ],
  priceDollars: 65,
  description: "The best kind of comfort is the kind that feels effortless. Designed for quiet mornings, relaxed afternoons, and everything in between, this set brings an elevated sense of ease to everyday living.\n\nFabrication:\nCrafted from Softies' original Serenity fabric, this set is celebrated for its rich velvety feel and irresistibly soft shear mink finish. \n\nFeatures:\n● Raglan sleeve construction creates a relaxed, easygoing silhouette\n● Wide-leg pant offers a comfortable fit with an elevated drape\n● Crew neckline provides timeless, versatile styling\n● Elastic waistband with 28\" inseam for all-day comfort and ease\n\nMaterials & Care:\n● 96% Polyester, 4% Spandex\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Relaxing at home in comfort\n● Slow mornings and unwinding at night\n● Thoughtful gifting and everyday lounging\n",
  tags: [],
  msrpDollars: 149,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:16.380Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
